import React from 'react';
import { FormattedMessage } from 'react-intl';
import messages from '../messages';

const name = <FormattedMessage {...messages.fulfillmentSKUColumnHeader} />;

export default {
  getMessageDescriptor: () => messages.fulfillmentSKUColumnHeader,
  name,
  render: (data) => data.fulfillmentSku || '',
};
